import { PageHeader, Card, Badge, MarkdownView, EmptyState } from '../ui';
import { useBinder } from '../../lib/useBinder';
import { useFocusHighlight, focusId } from '../../lib/useFocusHighlight';
import { ShowButton } from '../common/ShowButton';
import shared from './sections.module.css';

function optionalImage(entity: Record<string, unknown>): string | undefined {
  return typeof entity.image === 'string' ? entity.image : undefined;
}

/** Items and treasure cards for the current adventure. */
export function ItemsSection() {
  const ctx = useBinder();
  useFocusHighlight();
  if (!ctx) return null;
  const { adventure, instance, state, slug } = ctx;
  void state;

  return (
    <div>
      <PageHeader eyebrow="Inventario" title="Oggetti" />

      {!adventure.items.length ? (
        <EmptyState
          icon="🗝️"
          title="Nessun oggetto"
          description="Questa avventura non contiene oggetti preparati."
        />
      ) : (
        <div className={shared.grid}>
          {adventure.items.map((item) => (
            <Card key={item.id ?? item.name} id={focusId(item.id)}>
              <div className={shared.entityHead}>
                <span className={shared.entityIcon} aria-hidden>
                  {item.icon ?? '🗝️'}
                </span>
                <h2 className={shared.entityName}>{item.name}</h2>
                <div className={shared.cardActions}>
                  <ShowButton
                    slug={slug}
                    image={optionalImage(item)}
                    title={item.name}
                    instanceId={instance.id}
                  />
                </div>
              </div>

              <div className={shared.tagRow}>
                {item.type && <Badge tone="gold">{item.type}</Badge>}
                {item.location && <span className={shared.chip}>📍 {item.location}</span>}
              </div>

              {item.description && <MarkdownView>{item.description}</MarkdownView>}
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
